// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"cd024fef","20":"dc014c4a","365":"4e0040d5","565":"c5c5e3fb","626":"bfb1d975"}[chunkId] + ".chunk.js";
};